import { routes } from "./routeObject";
import { IRoutes } from "./route.interface";

export function getFlatRoute(_routes?: IRoutes[]): { [key: string]: IRoutes } {
    let result: { [key: string]: IRoutes } = {};

    function childrenLoop(item: IRoutes[], prevPath: string) {
        for (let index in item) {
            let { key, name, path, icon, children } = item[index];
            let fullPath;
            if (!path) {
                continue;
            }
            if (path.includes(":")) {
                // For routes with parameters, use the path without the parameter
                const pathWithoutParam = path.split('/:')[0];
                fullPath = prevPath ? prevPath + "/" + pathWithoutParam : pathWithoutParam;
            } else {
                fullPath = prevPath ? prevPath + "/" + path : path ?? "";
            }

            if (key) {
                Object.assign(result, { [key]: { name, path: fullPath, icon } });
            }

            if (children instanceof Array) {
                childrenLoop(children, fullPath);
            }
        }
    }

    const currentMap = _routes || routes;

    currentMap.map((item, index) => {
        let { key, name, path, icon, children } = item;

        if (key) {
            Object.assign(result, { [key]: { name, path, icon } });
        }

        if (children instanceof Array) {
            childrenLoop(children, path || "");
        }
    });

    return result;
}

export function getRoutePathArray(pathName: string): string[] {
    let locationArray: string[] = pathName.split("/").slice(1);
    let result: string[] = [];

    let currentPath = "";

    for (let i = 0; i < locationArray.length; i++) {
        if (i != 0) {
            currentPath += "/";
        }
        currentPath += locationArray[i];
        result.unshift(currentPath);
    }

    return result;
}

export function filterRouteObjectBypermission(routes: IRoutes[], permission: any): IRoutes[] {
    const handleChild = (routes: any): IRoutes[] => {
        const stackFilterChild: IRoutes[] = [];
        for (let index = 0; index < routes.length; index++) {
            const mapping = permission.find((list: any) => list?.roles_code === routes[index].code);
            if ((mapping && mapping?.read !== 0 && mapping?.roles_active !== 0) || !routes[index].code || routes[index].code === "00") {
                if (routes[index].children?.length > 0) {
                    const res = handleChild(routes[index].children);
                    if (res.length > 0) {
                        stackFilterChild.push({
                            ...routes[index],
                            children: res,
                            name: mapping?.roles_name ? mapping.roles_name : routes[index].name
                        });
                    } else {
                        stackFilterChild.push({
                            ...routes[index],
                            name: mapping?.roles_name ? mapping.roles_name : routes[index].name
                        });
                    }
                } else {
                    stackFilterChild.push({ ...routes[index], name: mapping?.roles_name ? mapping.roles_name : routes[index].name });
                }
            }
        }
        return stackFilterChild;
    };

    return handleChild(routes);
}
